/**
 * @description
 * */
import api from './api'
import CosmosModel from '@/model/CosmosModel'
import MonaModel from '@/model/MonaModel'
import TyrModel from '@/model/TyrModel'

const getMyVehicles = new MonaModel({ api: api.getC2cVehicles })
const queryVehicleSnapshot = new MonaModel({ api: api.queryVehicleSnapshot })
const queryVehicles = new MonaModel({ api: api.queryVehicles })
const queryVehicleDetail = new MonaModel({ api: api.queryVehicleDetail })
const collectCar = new MonaModel({ api: api.collectCar })
const cancelCollectCar = new MonaModel({ api: api.cancelCollectCar })
const queryCollectedList = new MonaModel({ api: api.collectList })
const createOrder = new MonaModel({ api: api.createOrder })
const getDeliveryCenters = new MonaModel({ api: api.getDeliveryCenters })
const getCardType = new MonaModel({ api: api.getCardType })
const registerCityModal = new MonaModel({ api: api.registerCities })
const getOrderTask = new MonaModel({ api: api.getOrderTask })
const getDepositAmount = new MonaModel({ api: api.getDepositAmount })
const getOwnerInfo = new MonaModel({ api: api.getOwnerInfo })
const editOwnerInfo = new MonaModel({ api: api.editOwnerInfo })
const viewPurchaseAgreement = new MonaModel({ api: api.viewPurchaseAgreement })
const getOrderDetail = new MonaModel({ api: api.getOrderDetail })
const getOrderTradeNo = new MonaModel({ api: api.getOrderTradeNo })
const getLocationWithCity = new MonaModel({ api: api.getLocationWithCity })
const cancelOrderModel = new MonaModel({ api: api.cancelOrder })
const getCancelReasons = new MonaModel({ api: api.getCancelReasons })
const queryTradeStatus = new MonaModel({ api: api.queryTradeStatus })
const queryOrderProtocols = new MonaModel({ api: api.queryOrderProtocols })
const commonConfigModel = new MonaModel({ api: api.commonConfig, needBrand: true })
const filterConditionConfigModel = new MonaModel({ api: api.filterConditionConfig })
const getOfficialCenter = new MonaModel({ api: api.getOfficialCenter })
const checkPayStatus = new MonaModel({ api: api.checkPayStatus })
const deleteOrder = new MonaModel({ api: api.deleteOrder })
const previewContract = new TyrModel({ api: api.previewContract })
const getRecommendFinanceProducts = new MonaModel({ api: api.getRecommendProduct })
const getCustomFinanceProducts = new MonaModel({ api: api.getCustomProducts })
const monthlyPaymentCalculation = new MonaModel({ api: api.monthlyPaymentCalculation })
const createLead = new MonaModel({ api: api.createLead })

export {
	getMyVehicles,
	queryVehicleSnapshot,
	queryVehicles,
	queryVehicleDetail,
	collectCar,
	cancelCollectCar,
	queryCollectedList,
	createOrder,
	getDeliveryCenters,
	getCardType,
	registerCityModal,
	getOrderTask,
	getDepositAmount,
	getOwnerInfo,
	editOwnerInfo,
	viewPurchaseAgreement,
	getOrderDetail,
	getOrderTradeNo,
	getLocationWithCity,
	cancelOrderModel,
	getCancelReasons,
	queryTradeStatus,
	queryOrderProtocols,
	commonConfigModel,
	filterConditionConfigModel,
	getOfficialCenter,
	checkPayStatus,
	deleteOrder,
	previewContract,
	getRecommendFinanceProducts,
	getCustomFinanceProducts,
	monthlyPaymentCalculation,
	createLead
}
